<!-- focus-card/-trigger (base.scss): the header's keyboard focus outline is drawn round the whole
     card, so it grows with the card when the section is expanded. -->
<div
  class="focus-card tw-w-full tw-items-center tw-rounded-2xl tw-bg-dt-surface-card-subtle tw-border"
  [ngClass]="isExpanded ? 'tw-border-teal-600' : 'tw-border-transparent'"
>
  <div
    class="focus-card-trigger tw-flex tw-h-12 tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-px-3 tw-rounded-2xl"
    [attr.data-testid]="testId"
    (click)="toggleExpand()"
    appKeyboardActivatable
    [appKeyboardActivatableExpanded]="isExpanded"
    (appKeyboardActivatableActivate)="toggleExpand()"
  >
    <span class="tw-font-bold tw-text-dt-text-headings">{{ title }}</span>
    <div class="tw-flex tw-gap-2 tw-items-center">
      <span
        class="tw-flex tw-items-center tw-gap-1 tw-py-1.5 tw-pl-3 tw-pr-2 tw-rounded-full tw-text-xs tw-shadow-card-elevated"
        [ngClass]="hasActiveFilter() ? 'tw-bg-teal-600 tw-text-white' : 'tw-bg-dt-surface-card'"
      >
        <span>{{ hasActiveFilter() ? title : getOptionsText() }}</span>
        @if (hasActiveFilter()) {
          <span
            class="tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-text-[11px] tw-font-bold tw-text-teal-600"
          >
            {{ selectedOptions.length }}
          </span>
        }
      </span>
      <icon
        [name]="isExpanded ? 'up-arrow' : 'down-arrow'"
        [size]="6"
        [currentColor]="'neutral-800'"
      ></icon>
    </div>
  </div>

  <div *ngIf="isExpanded" class="tw-w-full tw-bg-dt-surface-card-subtle tw-p-2 tw-rounded-2xl">
    <div class="tw-mb-1">
      <app-search-input
        [placeholder]="'Search ' + title"
        [value]="searchTerm()"
        [pageBg]="true"
        (valueChange)="onSearchChange($event)"
      ></app-search-input>
    </div>
    <!-- Each row's checkbox fills it (rounded and padded like the row), so its focus ring follows
         the row's shape and a click anywhere on the row is a click on the checkbox. The handler is
         on (onChange), not the row's (click): keyboard activation doesn't fire a click, so Enter/
         Space used to flip the box without changing the selection. -->
    <div
      class="tw-flex tw-h-12 tw-w-full tw-items-stretch tw-rounded-lg tw-ml-1 tw-mb-1
      {{
        isAllDisabled()
          ? 'tw-opacity-50 tw-cursor-not-allowed tw-bg-dt-surface-sunken hover:tw-bg-dt-surface-sunken'
          : 'tw-cursor-pointer hover:tw-bg-dt-surface-card'
      }}"
    >
      <app-checkbox
        class="tw-flex tw-w-full [&>div]:tw-w-full [&>div]:tw-items-center [&>div]:tw-px-3 [&>div]:tw-rounded-lg"
        [disabled]="isAllDisabled()"
        [checked]="areAllFilteredOptionsSelected()"
        [title]="selectAllText()"
        [background]="'teal-600'"
        (onChange)="selectAllOptions()"
      ></app-checkbox>
    </div>
    <div
      *ngFor="let option of filteredOptions(); trackBy: trackByFn"
      class="tw-flex tw-h-12 tw-w-full tw-items-stretch tw-rounded-lg tw-ml-1 tw-mb-1
      {{
        isDisabled(option.id)
          ? 'tw-opacity-50 tw-cursor-not-allowed tw-bg-dt-surface-sunken hover:tw-bg-dt-surface-sunken'
          : 'tw-cursor-pointer hover:tw-bg-dt-surface-card'
      }}"
      [ngClass]="{ 'tw-bg-dt-surface-action-hover-alt': isSelected(option.id) }"
    >
      <app-checkbox
        class="tw-flex tw-w-full [&>div]:tw-w-full [&>div]:tw-items-center [&>div]:tw-px-3 [&>div]:tw-rounded-lg"
        [disabled]="isDisabled(option.id)"
        [checked]="isSelected(option.id)"
        [title]="option.name"
        [background]="'teal-600'"
        (onChange)="toggleOption(option.id)"
      >
      </app-checkbox>
    </div>
  </div>
</div>
